import { ENV_LOCAL } from '@environment/.env';
import { ENV_BR } from '@environment/.env.br';
import { ENV_CO } from '@environment/.env.co';
import { ENV_DEV } from '@environment/.env.dev';
import { ENV_DEVELOPMENT } from '@environment/.env.development';
import { ENV_UY } from '@environment/.env.uy';

interface Environment {
  API: {
    TRAVEL: string;
    PROFILE: string;
    RULES: string;
    LOGIN: string;
    USER: string;
    COUNTRIES: string;
    LOGIN_EXCHANGE: string;
    RAPPI_SERVICES: string;
    RAPPI_SERVICES_CITIES: string;
    RAPPI_SERVICES_TRAVEL_CITY_SEARCH: string;
    RAPPI_SERVICES_TRAVEL_HOTEL_SEARCH: string;
    RAPPI_SERVICES_TRAVEL_HOTEL_CONTENT: string;
    RAPPI_IMAGES_CDN: string;
  };
  API_KEYS: {
    GOOGLE_MAPS_API_KEY: string;
    KUSTOMER_FORM_ID: string;
    AMPLITUDE_KEY: string;
  };
  RAPPI_OAUTH: {
    REDIRECT_URL_FROM_LOGIN: string;
    REDIRECT_URL_FROM_REGISTRATION: string;
    REDIRECT_URL_FROM_INVITE: string;
    LOGIN_CLIENTID: string;
    LOGIN_URL: string;
    SIGNUP_URL: string;
  };
  LANDING_PAGE: string;
  SENTRY_DSN: string;
  SEARCH_MAX_RESULT_PER_PAGE: number;
  COUNTRY_CODE: number;
  RAPPI_BRANCH_CODE: string;
}

const ENVIRONMENTS = {
  LOCAL: ENV_LOCAL,
  BR: ENV_BR,
  CO: ENV_CO,
  DEV: ENV_DEV,
  DEVELOPMENT: ENV_DEVELOPMENT,
  UY: ENV_UY,
};

const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as string;

export const ENV: Environment = ENVIRONMENTS[REACT_APP_ENVIRONMENT];
